/* TypeScript file generated from IconCard__Grid.res by genType. */
/* eslint-disable import/first */


const $$toRE210690488: { [key: string]: any } = {"Two": 0, "Three": 1};

// @ts-ignore: Implicit any on import
import * as IconCard__GridBS__Es6Import from './IconCard__Grid.bs';
const IconCard__GridBS: any = IconCard__GridBS__Es6Import;

import type {element as Jsx_element} from '../../../../src/shims/Jsx.shim';

// tslint:disable-next-line:interface-over-type-literal
export type perRowOnTablet = "Two" | "Three";

// tslint:disable-next-line:interface-over-type-literal
export type props<children,perRowOnTablet,amountOfTiles> = {
  readonly children: children; 
  readonly perRowOnTablet?: perRowOnTablet; 
  readonly amountOfTiles: amountOfTiles
};

export const make: (_1:props<JSX.Element,perRowOnTablet,number>) => Jsx_element = function (Arg1: any) {
  const result = IconCard__GridBS.make({children:Arg1.children, perRowOnTablet:(Arg1.perRowOnTablet == null ? Arg1.perRowOnTablet : $$toRE210690488[Arg1.perRowOnTablet]), amountOfTiles:Arg1.amountOfTiles});
  return result
};
